// ANCHOR React
import { ChangeEvent } from 'react';

// ANCHOR Base
import { ALIGN, Radio, RadioGroup } from 'baseui/radio';
import { LabelSmall } from 'baseui/typography';

// ANCHOR Models
import { useCreateFormQuestionFormType } from '@lyon/scoped-models/form/create/CreateFormQuestionForm';

// ANCHOR GraphQL
import { Form_Question_Types_Enum as QuestionType } from '@lyon/graphql/types';

// ANCHOR Hooks
import { useConstantCallback } from '@lyon/utils/hooks/useConstantCallback';

// ANCHOR Components
import { constant } from '@lyon/components/utils/constant';

// ANCHOR Constants
import { RADIOS, RADIO_NAME } from './constants';

// ANCHOR Styles
import { RADIO } from './styles';

export const LyonCreateFormQuestionType = constant(() => {
  const [type, setType] = useCreateFormQuestionFormType();

  const onChange = useConstantCallback((event: ChangeEvent<HTMLInputElement>) => {
    setType(event.target.value as QuestionType);
  });

  return (
    <RadioGroup
      value={type}
      onChange={onChange}
      name={RADIO_NAME}
      align={ALIGN.vertical}
    >
      <LabelSmall marginBottom="8px">
        {RADIO_NAME}
      </LabelSmall>
      {RADIOS.map((radio, index) => (
        <Radio
          key={index}
          value={radio.value}
          description={radio.description}
          overrides={RADIO}
        >
          {radio.label}
        </Radio>
      ))}
    </RadioGroup>
  );
});
